import _ from 'lodash';

export default function selector(storeState, props) {
    const open = _.get(storeState, 'creativeAuditWarningModal.isCreativeWarningOpen');
    return {
        open,
    };
}
